import { render, staticRenderFns } from "./CreateLive.vue?vue&type=template&id=08ef98d6&scoped=true&"
import script from "./CreateLive.vue?vue&type=script&lang=js&"
export * from "./CreateLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef98d6",
  null
  
)

export default component.exports